module.exports = "<scxml \n  xmlns=\"http://www.w3.org/2005/07/scxml\"\n  version=\"1.0\"\n  name=\"simpleLamp\">\n  <state id=\"off\">\n    <transition event=\"touch\" target=\"on\"/>\n  </state>\n  <state id=\"on\">\n    <transition event=\"touch\" target=\"off\"/>\n  </state>\n</scxml>\n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/light-switch-example/simple-lamp.scxml
// module id = 887
// module chunks = 199390669437303